export default __webpack_public_path__ + "static/media/EAST1060.34I-34182_-18428_0.854af8e7.jpg";